import Box from '@mui/material/Box';

// ----------------------------------------------------------------------

export function FormHead({ icon, title, description, slotProps, sx, ...other }) {
  return (
    <Box
      sx={[
        {
          gap: 3,
          display: 'flex',
          textAlign: 'center',
          alignItems: 'center',
          whiteSpace: 'pre-line',
          flexDirection: 'column',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {icon && icon}

      <Box>
        <Box
          sx={[
            { typography: 'h3' },
            ...(Array.isArray(slotProps?.title?.sx)
              ? (slotProps?.title?.sx ?? [])
              : [slotProps?.title?.sx]),
          ]}
        >
          {title}
        </Box>

        {description && (
          <Box
            sx={[
              { typography: 'body2', color: 'text.secondary' },
              ...(Array.isArray(slotProps?.description?.sx)
                ? (slotProps?.description?.sx ?? [])
                : [slotProps?.description?.sx]),
            ]}
          >
            {description}
          </Box>
        )}
      </Box>
    </Box>
  );
}
